import { $, $$, isMobile } from '@utils';
import { Calendar } from 'vanilla-calendar-pro';
import i18next from 'i18next';

function init() {
  if (!$('[data-au-datepicker]')) return;

  initDatepicker();
  datepickerDatalayer();
}

function initDatepicker() {
  const highlightedClass = 'au-datepicker__date-btn--highlighted';
  // Default options for all calendars
  const defaultOptions = {
    inputMode: true,
    locale: i18next.language,
    positionToInput: isMobile.matches ? 'auto' : undefined,
    styles: {
      calendar: 'au-datepicker',
      controls: 'au-datepicker__controls',
      grid: 'au-datepicker__grid',
      column: 'au-datepicker__column',
      header: 'au-datepicker__header',
      headerContent: 'au-datepicker__header-content',
      month: 'au-datepicker__month-selector',
      year: 'au-datepicker__year-selector',
      arrowPrev: 'au-datepicker__arrow au-datepicker__arrow--prev',
      arrowNext: 'au-datepicker__arrow au-datepicker__arrow--next',
      wrapper: 'au-datepicker__wrapper',
      content: 'au-datepicker__content',
      months: 'au-datepicker__months',
      monthsMonth: 'au-datepicker__month',
      years: 'au-datepicker__years',
      yearsYear: 'au-datepicker__year',
      week: 'au-datepicker__week',
      weekDay: 'au-datepicker__week-day',
      weekNumbers: 'au-datepicker__week-numbers',
      weekNumbersTitle: 'au-datepicker__week-numbers-title',
      weekNumbersContent: 'au-datepicker__week-numbers-content',
      weekNumber: 'au-datepicker__week-number',
      dates: 'au-datepicker__dates',
      date: 'au-datepicker__date',
      dateBtn: 'au-datepicker__date-btn',
      datePopup: 'au-datepicker__date-popup',
      dateRangeTooltip: 'au-datepicker__date-range-tooltip',
      time: 'au-datepicker__time',
      timeContent: 'au-datepicker__time-content',
      timeHour: 'au-datepicker__time-hour',
      timeMinute: 'au-datepicker__time-minute',
      timeKeeping: 'au-datepicker__time-keeping',
      timeRanges: 'au-datepicker__time-ranges',
      timeRange: 'au-datepicker__time-range',
    },
    onChangeToInput(self) {
      const input = self.context.inputElement;
      if (!input) return;
      if (self.context.selectedDates[0]) {
        input.value = formatDateToDDMMYYYY(self.context.selectedDates[0]);

        input.focus();
        // to trigger validation
        if (input.required) {
          input.blur();
        }

        // hide the calendar after picking a date
        self.hide();

        window.dataLayer.push({
          event: 'navigation',
          content_type: 'clickSelector',
          item_id: `selector_${input.value}`,
        });
      } else {
        input.value = '';
      }
    },
    onClickMonth(self) {
      setTimeout(() => {
        datePickerA11yAdjusts(self);
      }, 0);
    },
    onClickYear(self) {
      setTimeout(() => {
        datePickerA11yAdjusts(self);
      }, 0);
    },
    onShow(self) {
      setTimeout(() => {
        datePickerA11yAdjusts(self);
      }, 0);
    },
    onInit(self) {
      const input = self.context.inputElement;
      const calendar = self.context.mainElement;

      // set id to calendar to focus it when click on calendar icon (with spacebar or enter key)
      // eslint-disable-next-line no-extra-boolean-cast
      if (Boolean(self.inputMode)) {
        // if input has a setted value, go to that day on calendar
        if (input.value) {
          const selectedDate = datePickerGetClosestValidDate(formatDateToISO(input.value), calendar.dateMin);

          self.set({
            enableJumpToSelectedDate: true,
            selectedDates: [selectedDate],
          });
        }

        calendar.id = `cal-${input.id}`;

        input.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') {
            $(`#cal-${input.id}`).focus();
          }

          if (e.key === 'Tab') {
            self.hide();
          }
        });

        $(`#cal-${input.id}`).addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            input.focus();
          }
        });
      }
    },
    onClickArrow(self, e) {
      const direction = e.target.dataset.vcArrow === 'next' ? 'siguiente' : 'previa';

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickSlider',
        item_id: `fecha_${direction}`,
      });
    },
  };

  $$('[data-au-datepicker]').forEach((cal, index) => {
    // Store initialized calendar instances
    const calendarInstances = [];
    const calendarId = cal.querySelector('input').id; // Get unique ID
    const calendarTrigger = cal.dataset.auDatepickerInputMode ? `#${calendarId}` : cal;
    const calendarPopupsArray = cal.dataset.auDatepickerHighlightedDates
      ? cal.dataset.auDatepickerHighlightedDates.split(',')
      : undefined;
    let calendarPopups;

    if (calendarPopupsArray) {
      calendarPopups = calendarPopupsArray.reduce((acc, date) => {
        const cleanDate = date.replace(/'/g, ''); // Remove single quotes
        acc[cleanDate] = { modifier: highlightedClass };
        return acc;
      }, {});
    } else {
      calendarPopups = undefined;
    }

    const options = {
      ...defaultOptions,
      popups: calendarPopups,
      inputMode: cal.dataset.auDatepickerInputMode,
      disableDates: [cal.dataset.auDatepickerDisabledDates],
      dateMin: cal.dataset.auDatepickerMinDate ?? '1900-01-01',
      dateMax: cal.dataset.auDatepickerMaxDate ?? '2100-12-31',
    };

    // initialization
    const calendarInput = new Calendar(calendarTrigger, options);
    calendarInput.init();

    // Store the instance using the calendar's identifier
    calendarInstances[index] = calendarInput;

    // Find the clear button inside the datepicker element
    const clearBtn = cal.querySelector('[data-au-float-input-clear]');

    if (clearBtn) {
      // Attach click event to the corresponding clear button
      clearBtn.addEventListener('click', () => {
        calendarInstances[index].set({
          selectedDate: '',
        }); // Clear selected date
      });
    }

    // Find the input inside the datepicker element
    const input = cal.querySelector('input');

    if (input) {
      // format date as we write
      input.addEventListener('input', (e) => {
        formatTypedDate(e, calendarInstances[index]);
      });

      input.addEventListener('keydown', (e) => {
        // Allow Backspace, Delete, Tab, Arrow keys
        if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
          return;
        }

        // Prevent entering anything other than numbers
        if (!/^\d$/.test(e.key)) {
          e.preventDefault();
        }
      });
    }

    // calendar icon on click
    // eslint-disable-next-line no-extra-boolean-cast
    if (Boolean(calendarInput.inputMode)) {
      datePickerFocusOnCalendarIcon(calendarInstances);
    }
  });
}

// Function to adjust a11y
function datePickerA11yAdjusts(self) {
  const calendar = self.context.mainElement;

  // set tabindex="-1" so we cannot tabulate on week day because they havn't a funcionality
  calendar.querySelectorAll('[data-vc-week-day]').forEach((weekDay) => {
    weekDay.setAttribute('tabindex', '-1');
  });

  // remove role attributes to avoid critical errors of a11y
  calendar.querySelectorAll('[role="gridcell"]').forEach((gridCell) => {
    gridCell.removeAttribute('role');
  });

  calendar.querySelectorAll('[role="columnheader"]').forEach((gridCell) => {
    gridCell.removeAttribute('role');
  });

  calendar.querySelectorAll('[role="row"]').forEach((gridCell) => {
    gridCell.removeAttribute('role');
  });

  calendar.querySelectorAll('[data-vc="dates"]').forEach((gridCell) => {
    gridCell.removeAttribute('role');
  });
}
// Function to focus on input when click on calendar icon
function datePickerFocusOnCalendarIcon() {
  $$('[data-au-datepicker-calendar-icon]').forEach((calIcon) => {
    calIcon.addEventListener('keydown', (e) => {
      if (e.code === 'Space' || e.code === 'Enter') {
        setTimeout(() => {
          $(`#cal-${e.target.closest('[data-au-datepicker]').querySelector('input').id}`).focus();
        }, 200);
      }
    });

    calIcon.addEventListener('click', (e) => {
      e.target.closest('[data-au-datepicker]').querySelector('input').focus();
    });
  });
}

// Function to get the closest valid date in case of typin an invalid one
function datePickerGetClosestValidDate(dateString, dateMin) {
  const [year, month, day] = dateString.split('-').map(Number);

  // If any part of the date is zero, we return an invalid date
  if (year === 0 || month === 0 || day === 0) {
    return dateMin;
  }

  // Create a date object from the input
  const date = new Date(year, month - 1, day);

  // Check if the input date is valid (it should be valid if the date is within the valid range for that month)
  if (date.getFullYear() === year && date.getMonth() + 1 === month) {
    return dateString; // Return the original date if it's valid
  }

  // If the date is invalid, adjust the day to the last valid day of the month
  const lastDayOfMonth = new Date(year, month, 0).getDate();

  // Return the date with the adjusted valid day
  return `${year}-${String(month).padStart(2, '0')}-${String(lastDayOfMonth).padStart(2, '0')}`;
}

// Function to format date as we write
function formatTypedDate(e, calendar) {
  const input = e.target;
  let value = input.value;

  // if dd starts with 4 or more(X), the day will be 0X
  if (value[0] > 3) {
    value = `0${value}`;
  }

  // if mm starts with 1 or more(X), the month will be 0X
  if (value[2] > 1) {
    value = `${value.slice(0, 2)}/0${value.slice(2)}`;
  }

  // Remove all non-numeric characters
  value = value.replace(/[^0-9]/g, '');

  // Insert slash after the 2nd character (when typing the 3rd digit)
  if (value.length > 2 && value[2] !== '/') {
    value = `${value.slice(0, 2)}/${value.slice(2)}`;
  }

  // Insert slash after the 4th character (when typing the 5th digit)
  if (value.length > 5 && value[5] !== '/') {
    value = `${value.slice(0, 5)}/${value.slice(5)}`;
  }

  // Limit the length to 10 characters (dd/mm/yyyy)
  value = value.slice(0, 10);

  // Set the formatted value back to the input field
  input.value = value;

  if (value.length === 10) {
    if (value.slice(6, 10) < '1900') {
      value = `${value.slice(0, 6)}1900`;
      input.value = value;
    }

    if (value.slice(6, 10) > '2100') {
      value = `${value.slice(0, 6)}2100`;
      input.value = value;
    }

    const selectedDate = datePickerGetClosestValidDate(formatDateToISO(input.value), calendar.dateMin);
    input.value = formatDateToDDMMYYYY(selectedDate);

    // TO DO
    calendar.set({
      enableJumpToSelectedDate: true,
      selectedDates: [selectedDate],
    });

    setTimeout(() => {
      calendar.hide();
    }, 1000);
  }
}

// Function to format a date to ISO
function formatDateToISO(dateString) {
  // Validate the input format using a regular expression
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = dateString.match(regex);

  if (!match) {
    throw new Error('Invalid date format. Expected format: dd/mm/yyyy');
  }

  // Extract day, month, and year from the match array
  const day = match[1];
  const month = match[2];
  const year = match[3];

  // Return the reformatted date string in yyyy-mm-dd format
  return `${year}-${month}-${day}`;
}

// Function to format a date as DD/MM/YYYY
function formatDateToDDMMYYYY(dateString) {
  const [year, month, day] = dateString.split('-');

  // Return the date in dd/mm/yyyy format
  return `${day}/${month}/${year}`;
}

// Function to send datalayer when click on month and year selectors
function datepickerDatalayer() {
  document.addEventListener('click', (e) => {
    if (e.target.dataset.vc === 'month') {
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickSelector',
        item_id: 'selector_month',
      });
    }

    if (e.target.dataset.vc === 'year') {
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickSelector',
        item_id: 'selector_year',
      });
    }
  });
}

export default { init };
